// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wnRm","fullView":"styles_fullView__2PryE"};